// Controle de lido/nao lido do chat da sala.
//
// A versao anterior contava por QUANTIDADE de mensagens contra um contador que
// nascia zerado a cada carregamento da pagina. Isso dava dois defeitos ao
// mesmo tempo: o historico inteiro voltava como "nao lido" toda vez que a
// pessoa entrava, e a propria mensagem dela contava como nao lida.
//
// Agora a marca e o ID da ultima mensagem lida, guardado por usuario, e
// mensagem propria nunca conta.

const CHAVE = 'siti_sala_chat_lido';

export function lerMarcaDeLeitura(usuarioId) {
  if (!usuarioId) return 0;
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE) || '{}');
    const valor = Number(bruto?.[usuarioId]);
    return Number.isInteger(valor) && valor > 0 ? valor : 0;
  } catch (_) {
    return 0;
  }
}

export function gravarMarcaDeLeitura(usuarioId, ultimoId) {
  if (!usuarioId || !Number.isInteger(ultimoId) || ultimoId <= 0) return;
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE) || '{}');
    // Nunca anda para tras: uma aba antiga nao pode desmarcar o que outra
    // ja marcou como lido.
    if (Number(bruto?.[usuarioId]) >= ultimoId) return;
    localStorage.setItem(CHAVE, JSON.stringify({ ...bruto, [usuarioId]: ultimoId }));
  } catch (_) { /* modo anonimo / cota cheia: segue sem persistir */ }
}

// Maior id da lista. As mensagens chegam em ordem crescente, mas nao dependo
// disso — se um dia a ordem mudar, isto continua certo.
export function ultimoId(mensagens) {
  return (mensagens || []).reduce((maior, m) => Math.max(maior, Number(m.id) || 0), 0);
}

// Quantas mensagens de OUTRAS pessoas chegaram depois da marca de leitura.
export function contarNaoLidas(mensagens, meuId, marca) {
  if (!mensagens?.length) return 0;
  return mensagens.filter((m) => (
    Number(m.id) > marca
    && String(m.usuario_id) !== String(meuId)
  )).length;
}
